module.exports = __webpack_public_path__ + "img/sliders-horizontal.017b7aec.svg";